
import { callWithNuxt } from '#app'

export default defineNuxtRouteMiddleware( async (to) => {
  const nuxtApp = useNuxtApp()
  const runTimeConfig = useRuntimeConfig();
  
  
    try {
        let cryptext = encodeURIComponent(to.query.cry as string | number | boolean)
        await $fetch("/users/check-token", {
          method: "POST",
          headers: {
            token: runTimeConfig.public.token,
          },
          body: {
            cryptext:  cryptext,
          },
          baseURL: runTimeConfig.public.baseUrl,
        });
        
      } catch (e : any) {
        // console.log(e);
          return callWithNuxt(nuxtApp, navigateTo, ['/authentication/login'])

    }


})
